import React from 'react';
import PropTypes from 'prop-types';

class TaxCalculatorCheckboxes extends React.Component {
  static renderMobileView(singleProps, jointProps) {
    return (
      <div className="mobile-filing-status-inputs">
        <input {...singleProps} />
        <label htmlFor="single">Single</label>
        <input {...jointProps} />
        <label htmlFor="joint">Joint</label>
      </div>
    );
  }

  static renderDesktopView(singleProps, jointProps) {
    return (
      <React.Fragment>
        <div className="filing-status-inputs">
          <input {...singleProps} />
          <span className="checked-box" />
          <label htmlFor="single">Single</label>
        </div>
        <div className="filing-status-inputs">
          <input {...jointProps} />
          <span className="checked-box" />
          <label htmlFor="joint">Joint</label>
        </div>
      </React.Fragment>
    );
  }

  render() {
    const singleProps = {
      type: 'checkbox',
      name: 'single',
      checked: this.props.isSingle,
      onChange: this.props.updateFilingStatus,
    };

    const jointProps = {
      type: 'checkbox',
      name: 'joint',
      checked: !this.props.isSingle,
      onChange: this.props.updateFilingStatus,
    };

    if (this.props.mobile) {
      return TaxCalculatorCheckboxes.renderMobileView(singleProps, jointProps);
    }
    return TaxCalculatorCheckboxes.renderDesktopView(singleProps, jointProps);
  }
}

TaxCalculatorCheckboxes.defaultProps = {
  mobile: false,
  isSingle: true,
};

TaxCalculatorCheckboxes.propTypes = {
  mobile: PropTypes.bool,
  isSingle: PropTypes.bool,
  updateFilingStatus: PropTypes.func.isRequired,
};

export default TaxCalculatorCheckboxes;



// WEBPACK FOOTER //
// ./src-react/TaxCalculator/components/TaxCalculatorCheckboxes.jsx